import styled from '@emotion/styled'
import { css } from '@emotion/react'
import facepaint from 'facepaint'

import env from '@/lib/env'

const breakpoints = [375, 768, 1280]
const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`))

const breakpoints2 = [768]
const mq2 = facepaint(breakpoints2.map((bp) => `@media (min-width: ${bp}px)`))

const Container = styled.section`
  & {
    background-image: url('${
      env.BASE_PATH
    }/static/images/istockphoto-1133400370/istockphoto-1133400370-2048-x-2048.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
  }

  .decorator-container {
    overflow: visible;
    position: relative;
    width: 100vw;
    height: 100%;
  }

  #group-13 {
    position: absolute;
    width: calc(100vw - 1440px);
    max-width: 175px;
    right: 0;
    top: 1300px;
    transform: translate3d(0, -100%, 0);
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    margin: auto;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
  }

  .title-widget > span > .tertiary {
    position: relative;
  }

  .title-widget > span > .tertiary > svg {
    position: absolute;
    left: 0;
    top: 50%;
    height: 31px;
    transform: translate3d(calc(-100% - 400px), -50%, 0);
    fill: ${({ theme }) => theme.colors.primary[400]};
  }

  .title-widget > span > .tertiary > .rectangle {
    width: 100vw;
  }

  .title-widget > span > .tertiary > .circle {
  }

  .widget-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
    margin: 60px 0 60px 0;
    width: 100%;
    position: relative;
  }

  .document-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column nowrap;
    margin: 20px 0 64px 0;
    width: 100%;
    position: relative;
  }

  .title-widget {
    padding: 0 0 0 0;
  }

  .title-widget,
  .title-document {
    color: ${({ theme }) => theme.colors.font[0]};
  }

  .subtitle {
    color: ${({ theme }) => theme.colors.font[0]};
  }

  .grid-container {
    display: grid;
    grid-gap: 34px;
  }

  .documents-link {
    font-size: var(--fs-570);
    font-weight: 500;
    color: ${({ theme }) => theme.colors.font[0]};
    text-decoration: underline;
    margin: 49px 0 0 0;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
    text-align: center;
  }

  .documents-link:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  .documents-link:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  .documents-link > span {
    color: ${({ theme }) => theme.colors.tertiary[400]};
    text-decoration: underline;
  }

  .platform-link > * {
    margin: 48px 0;
    padding: 0 108px;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '.documents-link': {
          fontSize: [
            'var(--fs-100)',
            'var(--fs-100)',
            'var(--fs-500)',
            'var(--fs-570)',
          ],
        },
        '.widget-container': {
          padding: ['71px 0 0 0', '71px 0 0 0', '91px 0 0 0', '200px 0 0 0'],
        },
        '.document-container': {
          padding: [
            '50px 0 85px 0',
            '50px 0 85px 0',
            '100px 0 126px 0',
            '120px 0 164px 0',
          ],
        },
        '.title-widget > span > .tertiary > svg': {
          height: ['15px', '15px', '19px', '31px'],
        },
      }),
      mq({
        '.grid-container': {
          gridTemplateColumns: [
            'repeat(1, 1fr)',
            'repeat(1, 1fr)',
            'repeat(2, 1fr)',
            'repeat(3, 1fr)',
          ],
        },
      }),
      mq2({
        '.title-widget > span > .tertiary > svg': {
          transform: [
            'translate3d(calc(-100% - 220px), -50%, 0)',
            'translate3d(calc(-100% - 445px), -50%, 0)',
          ],
        },
      }),
    ).styles}}
`

export default Container
